// notificationSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { fetchDevices } from "./actions";
import { Device } from "../../types";

interface DeviceSlice {
  devices: Device[];
  count: number;
  loading: boolean;
}

const initialState: DeviceSlice = {
  devices: [],
  count: 0,
  loading: false,
};

const devicesSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDevices.fulfilled, (state, action) => {
      // state.devices = _.filter(action.payload?.data || [], {
      //   buildEnv: process.env?.REACT_APP_ENV || "dev",
      // });
      state.devices = action.payload?.data || [];
      state.count = action.payload?.count || 0;
      state.loading = false;
    });
    builder.addCase(fetchDevices.pending, (state, action) => {
      state.loading = true;
    });
  },
});

// export const { showNotification, hideNotification } = devicesSlice.actions;
export default devicesSlice.reducer;
